export const URL_ELEMENTAL = 'https://www.elementalinmobiliaria.com/'